import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from "uuid";
export class Registration extends AutoEncoder {
    constructor() {
        super(...arguments);
        /// Set registeredAt to null if the member is on the waiting list for now
        this.registeredAt = null;
        /// Keep spot for this member temporarily
        this.reservedUntil = null;
        this.deactivatedAt = null;
        this.createdAt = new Date();
        this.updatedAt = new Date();
        this.waitingList = false;
        this.canRegister = false;
        this.price = 0;
        this.pricePaid = 0;
        /// Payment can be null if the member is on a waiting list
        // @field({ decoder: Payment, nullable: true })
        // payment: Payment | null = null
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Registration.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Registration.prototype, "groupId", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], Registration.prototype, "cycle", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], Registration.prototype, "registeredAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], Registration.prototype, "reservedUntil", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], Registration.prototype, "deactivatedAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Registration.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Registration.prototype, "updatedAt", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 16 })
], Registration.prototype, "waitingList", void 0);
__decorate([
    field({ decoder: BooleanDecoder, version: 20 })
], Registration.prototype, "canRegister", void 0);
__decorate([
    field({ decoder: IntegerDecoder, optional: true })
], Registration.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder, optional: true })
], Registration.prototype, "pricePaid", void 0);
//# sourceMappingURL=Registration.js.map